import { ObjSerUtils } from "../../DiscoveryEngine.TS/Serialization/ObjSerUtils";
import { StorageRootDto } from "../StorageRootDto";
import { DiscoveryResult } from "../../DiscoveryEngine.TS/Core/DiscoveryResult";

export class ScheduledDiscoveryResultDto extends StorageRootDto {

	public UserGuid: string;
	public ScopeGuid: string;
	public AgentGuid: string;
	public ClientAgentGuid: string;
	public SchedDiscGuid: string;
	public RawDiscResult: DiscoveryResult;
	public RollupDiscResult: DiscoveryResult;
	public StartTime: string;
	public EndTime: string;
	public DeviceCount: number;

	constructor() {
		super();

		this.UserGuid = "";
		this.ScopeGuid = "";
		this.AgentGuid = "";
		this.ClientAgentGuid = "";
		this.SchedDiscGuid = "";
		this.RawDiscResult = null;
		this.RollupDiscResult = null;
		this.StartTime = "";
		this.EndTime = "";
		this.DeviceCount = 0;
	}

	public get HasUserGuid(): boolean {
		return !!this.UserGuid;
	}

	public get HasScopeGuid(): boolean {
		return !!this.ScopeGuid;
	}

	public get HasAgentGuid(): boolean {
		return !!this.AgentGuid;
	}

	public get HasClientAgentGuid(): boolean {
		return !!this.ClientAgentGuid;
	}

	public get HasSchedDiscGuid(): boolean {
		return !!this.SchedDiscGuid;
	}

	public get HasRawDiscResult(): boolean {
		return !!this.RawDiscResult;
	}

	public get HasRollupDiscResult(): boolean {
		return !!this.RollupDiscResult;
	}

	public get HasStartTime(): boolean {
		return !!this.StartTime;
	}

	public get HasEndTime(): boolean {
		return !!this.EndTime;
	}

	public Write(obj: any, context: any): void {
		obj.scheduled_discovery_result = {};
		obj = obj.scheduled_discovery_result;

		super.Write(obj, context);

		if (this.HasUserGuid)
			obj.user_guid = this.UserGuid;

		if (this.ScopeGuid)
			obj.scope_guid = this.ScopeGuid;

		if (this.HasAgentGuid)
			obj.agent_guid = this.AgentGuid;

		if (this.HasClientAgentGuid)
			obj.client_agent_guid = this.ClientAgentGuid;

		if (this.HasSchedDiscGuid)
			obj.sched_disc_guid = this.SchedDiscGuid;

		if (this.HasRawDiscResult) {
			context[DiscoveryResult.ObjSerName] = "raw_discovery_result"
			this.RawDiscResult.Write(obj, context);
		}

		if (this.HasRollupDiscResult) {
			context[DiscoveryResult.ObjSerName] = "rollup_discovery_result";
			this.RollupDiscResult.Write(obj, context);
		}

		if (this.HasStartTime)
			obj.start_time = this.StartTime;

		if (this.HasEndTime)
			obj.end_time = this.EndTime;

		if (this.DeviceCount > 0)
			obj.device_count = this.DeviceCount;
	}

	public Read(obj: any, context: any): void {

		if (!obj.scheduled_discovery_result)
			throw new Error();
		obj = obj.scheduled_discovery_result;

		super.Read(obj, context);

		if (obj.user_guid !== undefined)
			this.UserGuid = obj.user_guid;

		if (obj.scope_guid !== undefined)
			this.ScopeGuid = obj.scope_guid;

		if (obj.agent_guid !== undefined)
			this.AgentGuid = obj.agent_guid;

		if (obj.client_agent_guid !== undefined)
			this.ClientAgentGuid = obj.client_agent_guid;

		if (obj.sched_disc_guid !== undefined)
			this.SchedDiscGuid = obj.sched_disc_guid;

		if (obj.raw_discovery_result !== undefined) {
			this.RawDiscResult = new DiscoveryResult();
			context[DiscoveryResult.ObjSerName] = "raw_discovery_result";
			this.RawDiscResult.Read(obj, context);
		}

		if (obj.rollup_discovery_result !== undefined) {
			this.RollupDiscResult = new DiscoveryResult();
			context[DiscoveryResult.ObjSerName] = "rollup_discovery_result";
			this.RollupDiscResult.Read(obj, context);
		}

		if (obj.start_time !== undefined)
			this.StartTime = obj.start_time;

		if (obj.end_time !== undefined)
			this.EndTime = obj.end_time;

		if (obj.device_count != undefined)
			this.DeviceCount = obj.device_count;
	}

}
